import React from "react";
import { Typography, IconButton } from "@mui/material";
import {
  CheckCircle as CheckCircleIcon,
  ChevronRight as ChevronRightIcon,
  Brightness1Outlined as Brightness1OutlinedIcon,
} from "@mui/icons-material";
import {
  StyledCard,
  StyledCardContent,
  StyledHeaderBox,
  StyledMetricValue,
  StyledStatContainer,
} from "./InsightCardShared";
import StatItem from "./StatItem";

interface InsightCardClausesProps {
  title: string;
  clauses: {
    found: number;
    notFound: number;
    notAnalyzed?: number;
  };
  onClick?: () => void;
}

const InsightCardClauses: React.FC<InsightCardClausesProps> = ({
  title,
  clauses,
  onClick,
}) => {
  const total = clauses.found + clauses.notFound;

  return (
    <StyledCard
      onClick={onClick}
      sx={{ cursor: onClick ? "pointer" : "default" }}
    >
      <StyledCardContent>
        <StyledHeaderBox>
          <Typography variant="subtitle2">{title}</Typography>
          <IconButton
            size="small"
            sx={{
              color: "primary.main",
              "&:hover": {
                backgroundColor: "primary.light",
                color: "white",
              },
            }}
          >
            <ChevronRightIcon />
          </IconButton>
        </StyledHeaderBox>

        <StyledMetricValue variant="h3" color="primary">
          {total}
        </StyledMetricValue>

        <StyledStatContainer>
          <StatItem
            label="Matched"
            value={clauses.found}
            icon={CheckCircleIcon}
            iconColor="success"
          />
          <StatItem
            label="Missing"
            value={clauses.notFound}
            icon={Brightness1OutlinedIcon}
            iconColor="error"
          />
          {clauses.notAnalyzed && (
            <StatItem
              label="Not analyzed"
              value={clauses.notAnalyzed}
              icon={Brightness1OutlinedIcon}
              iconColor="error"
            />
          )}
        </StyledStatContainer>
      </StyledCardContent>
    </StyledCard>
  );
};

export default InsightCardClauses;
